import React from 'react';
import { XCircle } from 'lucide-react';
import { motion } from 'framer-motion';
export function PainPoints() {
  const points = ['Cada vez que le sacás el celular termina en un berrinche que agota a toda la familia', 'Le decís "5 minutitos más" porque sabés lo que viene si no', 'Intentaste actividades alternativas pero a los 10 minutos está pidiendo la tablet de nuevo', 'Sentís que tu hijo solo está tranquilo con una pantalla enfrente', 'La hora de comer, el auto, la espera en el médico — todo depende del celular', 'Te fuiste a dormir pensando "mañana lo cambio" y mañana fue igual'];
  return <section className="bg-dark-800 py-20 px-4" data-id="element-135">
      <div className="max-w-4xl mx-auto" data-id="element-136">
        <div className="text-center mb-12" data-id="element-137">
          <h2 className="text-3xl md:text-5xl font-bold text-cream mb-6 leading-tight" data-id="element-138">
            ¿Cuántas noches más vas a terminar sintiéndote culpable?
          </h2>
          <p className="text-xl text-cream/80 mb-4" data-id="element-139">
            Sos un buen padre. Una buena madre. Amás a tu hijo con todo.
          </p>
          <p className="text-lg text-cream/70 mb-8" data-id="element-140">
            Pero nadie te dijo que en 2025 ibas a tener que competirle la
            atención a un algoritmo diseñado por los mejores ingenieros del
            mundo para que tu hijo no pueda parar de mirar la pantalla.
          </p>
          <p className="text-xl font-semibold text-primary" data-id="element-141">
            No es debilidad tuya. No es mala crianza. Es que el celular gana
            siempre... si no tenés un sistema.
          </p>
        </div>

        <div className="bg-dark-900 rounded-3xl p-8 md:p-12 border border-urgency/20 shadow-2xl" data-id="element-142">
          <h3 className="text-2xl font-bold text-cream mb-8 flex items-center" data-id="element-143">
            <XCircle className="w-8 h-8 text-urgency mr-3" data-id="element-144" />
            ¿Esto te suena familiar?
          </h3>

          <ul className="space-y-6" data-id="element-145">
            {points.map((point, i) => <motion.li initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} key={i} className="flex items-start" data-id="element-146">
                <span className="text-urgency mr-4 text-xl mt-1" data-id="element-147">❌</span>
                <span className="text-lg text-cream/90" data-id="element-148">{point}</span>
              </motion.li>)}
          </ul>
        </div>

        <div className="text-center mt-12" data-id="element-149">
          <p className="text-2xl md:text-3xl font-bold text-cream italic" data-id="element-150">
            ¿Y si este fuera el último día que lo pensás sin hacer nada?
          </p>
        </div>
      </div>
    </section>;
}